import {get_token} from "@/router";

export default {
    data() {
        return ({
          token_exists: false,
          user_details: {
            "user_role": '',
            "user_id": '',
          },
          isSubmitting: false,
          topics:[],
          created_by_id:this.created_by,
          portals:[],
          isMaster: false,
          categories: [],
          selectedPortalId: null,
          selectedTopicId: null,
          searchQuery:"",
          errors: {
            voice_description:null,
            voice_name:null,
            portal: null,
            segment: null,
            report_description: null
          },
          users:[],
          portal_types:[],
          selectedPortalType:null,
          payload:{},
          reviewers: [],
          event_types:[],
          event_type: '',
        });
      },
    methods:{
        getToken() {
            return get_token();
        },
        validationSegmentForm() {
            this.errors = {};
            let valid = true;
        
            if (!this.topic_name) {
                this.errors.topic_name = 'Segment name is required';
                valid = false;
            }
        
            if (!this.selectedPortalId) {
                this.errors.portal = "You must tag a portal.";
            }
        
            return valid;
            },
        createSegment() {
            if(!this.validationSegmentForm()) {
              return;
            }
             $('#segment_modal').modal('hide')
      
            this.isSubmitting = true;
      
            const requestData = {
                topic_name: this.topic_name,
                portal_id: this.$route.params.portal_id
              };
      
            $.ajax({
              type: "POST",
              url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_topic_api/`,
              contentType: "application/json",
              headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
              },
              data: JSON.stringify(requestData),
              success: (response) => {
                this.$emit('newSegment',response.topic)
      
                const status = response.status;
                if (status === "success") {
      
                  this.topics.push(response.topic);
      
                  this.topic_name = '';
                  this.errors.topic_name = '';
                }
              },
              error: (response) => {
                const response_data = response.responseJSON;
                if(response_data.status=="error"){
                 this.errors.topic_name=response_data.message
                }
            },
              complete: () => {
                this.isSubmitting = false;
              }
            });
          },
    }  
}